<template>
    <div v-if="path" class="buttonFloat" :class="{disabled: path === 'null'}" @click="redirect"><i :class="icon"></i></div>
    <div v-else class="buttonFloat" @click="clickEvent"><i :class="icon"></i></div>
</template>

<script>
export default {
  name:"ButtonFloat",
  props:{
    icon:String,
    path:String
  },
  methods: {
    redirect() {
      if(this.path !== "null") {
        this.$router.push({name:this.path});
      } else {
        return ;
      }
    },
    clickEvent() {
      this.$emit("event");
    }
  }
}
</script>

<style scoped>
  .buttonFloat {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    position: fixed;
    bottom: 32px;
    right: 32px;
    z-index: 90;
    background: var(--jersey-yellow);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 6px 18px rgba(185, 131, 0, .45);
    transition: transform .15s ease, box-shadow .15s ease, background-color .15s ease;
  }
  .buttonFloat:hover {
    transform: translateY(-2px) scale(1.05);
    background: var(--jersey-yellow-dark);
    box-shadow: 0 10px 24px rgba(185, 131, 0, .5);
  }
  .buttonFloat.disabled {
    opacity: .55;
    cursor: not-allowed;
  }
  i {
    color: white;
    font-size: 2.1rem;
  }
</style>
